import React from "react";
import ReactDOM from "react-dom";
import AppRouter from "../routes"; // 从新的路由目录导入
import "flex.css";
import { App, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { LoadingProvider } from "@/components/global-loading/index.jsx"; // Import LoadingProvider

const AppRenderer = (appTarget) => {
    ReactDOM.render(
        <ConfigProvider locale={zhCN}>
            <LoadingProvider>
                <AppRouter />
            </LoadingProvider>
        </ConfigProvider>,
        appTarget
    );
};

export default AppRenderer;
